import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { DataMap } from '@grapecity/wijmo.grid'

import { BaseComponent, FeatureType, Grid, MaterialLocationQuantity, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { SmallToolLocationComponent } from './small-tool-location.component'

@Component({
    templateUrl: './small-tool-locations.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class SmallToolLocationsComponent extends BaseComponent {
    faSearch = faSearch
    grid: Grid<MaterialLocationQuantity>
    rawLocations: any[] = []
    rawMaterials: any[] = []
    locationMap!: DataMap
    materialMap!: DataMap
    constructor() {
        super()
        this.grid = new Grid<MaterialLocationQuantity>(this.services)
            .setupModalEditing(
                this.services.data.materialLocationQuantities,
                'Small Tool Location',
                SmallToolLocationComponent,
                () => new MaterialLocationQuantity(),
                this,
                ModalSize.medium,
            )
            .filterBy(item => [item.material, item.location])
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.materialLocationQuantities.queryAllByAction('GetTools'),
                    this.services.data.get('/api/VpMaterial/GetSmallToolLocations'),
                    this.services.data.get('/api/VpMaterial/GetSmallTools'),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.grid.items = result[0]
                        this.rawLocations = result[1]
                        this.rawMaterials = result[2]

                        this.locationMap = new DataMap(this.rawLocations, 'key', 'value')
                        this.materialMap = new DataMap(this.rawMaterials, 'barcode', 'name')
                    },
                }),
        )
    }
    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.ToolRoomRecordsEdit])
    }
}
